import { initContract } from '@ts-rest/core';
import { publicGiftcloudContract } from './giftcloud.public.contract';

const c = initContract();

export const giftcloudContract = c.router(
  {
    public: publicGiftcloudContract,
  },
  {
    pathPrefix: '/giftcloud',
    strictStatusCodes: true,
  }
);

export * from './giftcloud.public.contract';
export * from './models';

